import { render, staticRenderFns } from "./ExamTab.vue?vue&type=template&id=569412ce"
import script from "./ExamTab.vue?vue&type=script&lang=js"
export * from "./ExamTab.vue?vue&type=script&lang=js"
import style0 from "./ExamTab.vue?vue&type=style&index=0&id=569412ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports